import * as React from "react";
import { tinycolor } from "@ctrl/tinycolor";
import {
    makeStyles,
    Button,
    Popover,
    PopoverSurface,
    PopoverTrigger,
} from "@fluentui/react-components";
import {
    ColorPicker as FluentColorPicker,
    ColorSlider,
    AlphaSlider,
    ColorPickerProps,
    ColorArea,
} from "@fluentui/react-components";

const useStyles = makeStyles({
    example: {
        width: "300px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
    },
    previewColor: {
        width: "40px",
        height: "36px",
        borderRadius: "4px",
        border: "1px solid #aaaaaa",
        cursor: "pointer",
        "@media (forced-colors: active)": {
            forcedColorAdjust: "none",
        },
    },
    row: {
        display: "flex",
        gap: "10px",
    },
    sliders: {
        display: "flex",
        flexDirection: "column",
    },
});

export const ColorPicker = ({ defaultColor, setDefaultColor }) => {
    const styles = useStyles();
    const DEFAULT_COLOR_HSV = tinycolor(defaultColor).toHsv();

    const [previewColor, setPreviewColor] = React.useState(DEFAULT_COLOR_HSV);
    const [color, setColor] = React.useState(defaultColor);
    const [popoverOpen, setPopoverOpen] = React.useState(false);

    const handleChange = (_, data) => {
        setPreviewColor({ ...data.color, a: data.color.a ?? 1 });
    };

    return (
        <>
            <Popover
                open={popoverOpen}
                trapFocus
                onOpenChange={(_, data) => setPopoverOpen(data.open)}
            >
               <PopoverTrigger disableButtonEnhancement>
                <div
                    className={styles.previewColor}
                    style={{ backgroundColor: `${tinycolor(previewColor).toRgbString()}` }}
                    onClick={() => setPopoverOpen(true)}
                ></div>
            </PopoverTrigger>

                <PopoverSurface>
                <FluentColorPicker color={previewColor} onColorChange={handleChange}>
                    <ColorArea
                        inputX={{ "aria-label": "Saturation" }}
                        inputY={{ "aria-label": "Brightness" }}
                    />
                    <div className={styles.row}>
                        <div className={styles.sliders}>
                            <ColorSlider aria-label="Hue" />
                            <AlphaSlider aria-label="Alpha" />
                        </div>
                        <div
                            className={styles.previewColor}
                            style={{
                                backgroundColor: tinycolor(previewColor).toRgbString(),
                            }}
                        />
                    </div>
                </FluentColorPicker>
                    <div className={styles.row}>
                        <Button
                            appearance="primary"
                            onClick={() => {
                                const hexColor = tinycolor(previewColor).toHexString();
                                setColor(previewColor);
                                setDefaultColor(hexColor);
                                setPopoverOpen(false);
                            }}
                        >
                            Ok
                        </Button>
                        <Button onClick={() => setPopoverOpen(false)}>Cancel</Button>
                    </div>
                </PopoverSurface>
            </Popover>
        </>
    );
};
